<template>
  <div>
    <FragebogenModule
      :fragebogenIdentifier="fragebogenIdentifier"
      :zwischenstandAktuell="zwischenstandAktuell"
    />
    <div class="fragebogenButtons">
      <v-row>
        <v-col>
          <b-btn @click="ladeProjektDetails()"> zurück </b-btn>
        </v-col>
        <v-col cols="auto">
          <b-btn
            class="mr-6"
            @click="antwortenExportieren()"
          >
            Antworten exportieren
          </b-btn>
          <b-btn @click="fragebogenSpeichern()">Speichern</b-btn>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
import FragebogenModule from '@/views/fragebogen/FragebogenModule';
import tooltips_text from '@/utils/data/tooltips';
import axios from 'axios';
import _ from 'lodash';
import fileDownload from "js-file-download";

export default {
  name: 'FragebogenZwischenstandUebersicht',
  components: { FragebogenModule },
  props: {
    uuid: {
      type: [Number, String],
    },
    position: {
      type: [Number, String],
    },
    aktuell: {
      Boolean: [Boolean],
    },
  },
  data() {
    return {
      fragebogenIdentifier: {
        typ: 'fragebogen/zwischenstand?',
        parameter: {
          id: this.uuid,
          position: this.position,
        },
      },
      snackbar: {
        show: false,
        color: '',
        text: '',
        timeout: 4000,
      },
      zwischenstandAktuell: false,
      tooltips: tooltips_text,
    };
  },
  created: function () {
    this.ladeFragebogenStatus();
  },
  computed: {
    oeffneSnackbarErfolg() {
      return (response) => {
        if (200 <= response.statusCode < 300) {
          this.snackbar.color = `primary`;
          this.snackbar.text = `Erfolgreich gespeichert`;
          this.snackbar.show = true;
        }
      };
    },
    oeffneSnackbarFehlschlag() {
      return (err) => {
        this.snackbar.color = `red`;
        this.snackbar.text = `${err.response.status} Fehler beim speichern`;
        this.snackbar.show = true;
      };
    },
  },
  mixins: [dataMixin('fragebogen', 'loadedData.fragebogen')],
  methods: {
    fragebogenSpeichern() {
      let payload = _.cloneDeep(this.fragebogen);
      axios.put(`/v1/fragebogen/${this.fragebogen.id}`, payload).then(
        (response) => this.oeffneSnackbarErfolg(response),
        (err) => this.oeffneSnackbarFehlschlag(err)
      );
    },
    ladeFragebogenStatus() {
      axios.get(`/v1/fragebogen/istOffen?id=${this.uuid}`).then((response) => {
        this.zwischenstandAktuell = !response.data
          ? this.aktuell == 'true'
            ? true
            : false
          : false;
      });
    },
    ladeProjektDetails() {
      this.$router.push('/projekt/' + this.fragebogen.projektId);
    },
    antwortenExportieren() {
      const params = {
        id: this.uuid,
        position: this.position,
        responseType: 'blob'
      };
      const antworten = axios.post(`/v1/fragebogen/antworten`,  params,  {responseType: 'blob'} );
      antworten.then((data) => {
        fileDownload(data.data, 'exportierteAntworten.xlsx');
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.fragebogenZwischenstand {
  padding-bottom: 60px;
  h2 {
    margin-bottom: 20px;
  }
  .fragebogenHeader {
    margin-bottom: 20px;
  }
  .fragebogenButtons {
    float: right;
  }
}
</style>